import React, { useState } from 'react';
import './OTPModal.css';
import Button from './common/Button';

const OTPModal = ({
	isOpen = true,
	onClose = () => {},
	customDetails,
	mobileNumber = '',
	OTP = '',
	time = 60,
	isResend = false,
	verifySpinner = false,
	isVerifyDisabled = false,
	onOTPChange = () => {},
	onResendOtp = () => {},
	onVerifyOtp = () => {},
}) => {
	const [otpValue, setOtpValue] = useState(OTP);

	const handleOTPChange = (value) => {
		setOtpValue(value);
		onOTPChange(value);
	};

	if (!isOpen) return null;

	return (
		<div className="otp-modal-backdrop">
			<div className="otp-modal-content" style={{ width: '40%', margin: '0 auto' }}>
				<button className="otp-modal-close" onClick={onClose}>
					×
				</button>

				<h2
					className="otp-modal-title"
					style={{
						color: customDetails?.textColor,
						fontFamily: customDetails?.fontFamily,
						textAlign: 'left',
						color: 'black',
					}}
				>
					Verify mobile number
				</h2>

				<p
					className="otp-modal-subtitle"
					style={{
						fontFamily: customDetails?.fontFamily,
						textAlign: 'left',
					}}
				>
					Please enter the OTP sent to your registered mobile number
				</p>

				<input
					type="text"
					inputMode="numeric"
					placeholder="Enter OTP"
					value={otpValue}
					onChange={(e) => handleOTPChange(e.target.value)}
					className="otp-modal-input"
					style={{
						fontFamily: customDetails?.fontFamily,
						'--focus-color': customDetails?.primaryColor,
						width: '50%',
						display: 'block',
						marginLeft: 0,
					}}
				/>

				<div className="otp-modal-resend">
					<button
						onClick={onResendOtp}
						disabled={!isResend}
						className={`otp-modal-resend-btn ${
							isResend ? 'enabled' : 'disabled'
						}`}
						style={{
							color: isResend ? customDetails?.primaryBtnColor : '#ccc',
							fontFamily: customDetails?.fontFamily,
						}}
					>
						Didn't receive OTP? Try Again
					</button>
					{time !== 60 && (
						<span
							className="otp-modal-timer"
							style={{
								fontFamily: customDetails?.fontFamily,
							}}
						>
							in {time} sec
						</span>
					)}
				</div>

				<hr
					style={{
						width: '100%',
						marginLeft: 0,
						marginTop: 8,
						marginBottom: 16,
					}}
				/>

				<div className="otp-modal-actions">
					<Button
						onClick={onVerifyOtp}
						disabled={isVerifyDisabled}
						// color={isVerifyDisabled ? '#ccc' : customDetails?.primaryBtnColor}
						style={{
							borderRadius: customDetails?.borderRadius,
							backgroundColor: isVerifyDisabled
								? '#ccc'
								: customDetails?.primaryBtnColor,
							fontFamily: customDetails?.fontFamily,
							'--hover-color': '#3730A3',
						}}
					>
						{verifySpinner ? <div className="otp-modal-spinner" /> : 'Verify'}
					</Button>
					<Button
						onClick={onClose}
						text="Cancel"
						color={customDetails?.primaryBtnColor}
						variant="outlined"
						borderColor={customDetails?.btnBorderColor}
						style={{
							borderRadius: customDetails?.borderRadius,
							fontFamily: customDetails?.fontFamily,
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default OTPModal;
